export const APP_MANIFEST = 'manifests/launcher.json';
export const APP_CONFIGURATION = 'shared/apps.json';
